var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_116411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3408 4.76693L16.4043 8.38916L21.2227 9.63932L22.1591 6.01709L17.3408 4.76693Z",
    fill: "#456EBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4168 7.24716C24.3309 7.57858 23.9901 7.78084 23.6562 7.69373L15.2218 5.50495C14.892 5.41884 14.6901 5.07641 14.7761 4.74499L15.7125 1.1234C15.7985 0.790975 16.1403 0.590721 16.4701 0.675829L24.9046 2.8646C25.2384 2.95171 25.4383 3.29215 25.3523 3.62457L24.4158 7.24616L24.4168 7.24716Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.674 15.9846L26.4097 13.8359L29.6309 11.9385L30.8933 14.0882L27.674 15.9846Z",
    fill: "#456EBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1251 15.7121C30.8273 15.8863 30.4315 15.7612 30.2376 15.4318L28.1368 11.8572C27.9439 11.5288 28.0278 11.1173 28.3237 10.9441L30.4685 9.67847C30.7623 9.50424 31.1631 9.6304 31.355 9.95882L33.4569 13.5344C33.6498 13.8628 33.5658 14.2723 33.271 14.4475L31.1251 15.7121Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96515 6.34244L5.81889 7.60645L7.71172 10.8321L9.85798 9.56809L7.96515 6.34244Z",
    fill: "#456EBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82821 8.91637C5.00311 9.21174 5.41189 9.29685 5.73971 9.10261L9.30777 6.99794C9.63559 6.80469 9.76252 6.40418 9.58662 6.10981L8.32531 3.96008C8.1544 3.66571 7.74362 3.5796 7.4158 3.77285L3.84574 5.87752C3.51692 6.06976 3.39399 6.47027 3.56589 6.76564L4.82921 8.91537L4.82821 8.91637Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8426 26.0461C27.7737 34.0463 19.6211 38.8544 11.6355 36.7817C3.65082 34.7101 -1.14857 26.5418 0.920305 18.5416C2.98918 10.5405 11.1427 5.73437 19.1274 7.807C27.1131 9.87963 31.9115 18.046 29.8426 26.0471V26.0461Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4326 25.4218C25.7085 32.0902 18.9142 36.0943 12.2588 34.3671C5.60546 32.6399 1.60663 25.8353 3.3307 19.1668C5.05476 12.4994 11.8481 8.49529 18.5024 10.2215C25.1578 11.9487 29.1567 18.7543 27.4326 25.4208V25.4218Z",
    fill: "#F2F1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1902 22.7631C16.9324 23.7623 15.9119 24.3651 14.9125 24.1058C13.916 23.8474 13.3163 22.8231 13.5742 21.8249C13.8331 20.8246 14.8525 20.2238 15.849 20.4832C16.8484 20.7425 17.4481 21.7638 17.1892 22.7631H17.1902Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9289 13.5524C18.757 14.2193 18.0764 14.6198 17.4107 14.4476C16.7451 14.2754 16.3473 13.5935 16.5192 12.9276C16.6921 12.2608 17.3697 11.8603 18.0344 12.0335C18.7 12.2057 19.1008 12.8866 18.9279 13.5534L18.9289 13.5524Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0908 12.9476C14.2747 13.6104 13.888 14.2983 13.2253 14.4825C12.5617 14.6657 11.875 14.2762 11.6931 13.6134C11.5102 12.9496 11.896 12.2617 12.5597 12.0795C13.2223 11.8952 13.9089 12.2837 14.0908 12.9486V12.9476Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59662 14.8454C10.0884 15.329 10.0953 16.119 9.61361 16.6097C9.13187 17.1013 8.3433 17.1063 7.85257 16.6247C7.36283 16.1411 7.35684 15.3511 7.83858 14.8604C8.32031 14.3688 9.10989 14.3638 9.59662 14.8444V14.8454Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65559 18.7397C7.32123 18.9129 7.72201 19.5928 7.5491 20.2596C7.3772 20.9265 6.69657 21.326 6.03193 21.1548C5.36729 20.9805 4.96451 20.2997 5.13841 19.6348C5.31132 18.968 5.99095 18.5685 6.65559 18.7407V18.7397Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05257 23.5873C6.71521 23.403 7.40084 23.7915 7.58274 24.4554C7.76864 25.1202 7.37685 25.8051 6.71521 25.9913C6.05457 26.1736 5.36794 25.7841 5.18504 25.1222C5.00214 24.4574 5.38793 23.7705 6.05157 23.5883L6.05257 23.5873Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94989 28.087C8.42962 27.5954 9.2172 27.5874 9.70893 28.072C10.1997 28.5546 10.2027 29.3446 9.72492 29.8352C9.24018 30.3249 8.45361 30.3319 7.96288 29.8483C7.47214 29.3657 7.46615 28.5777 7.95088 28.087H7.94989Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8347 31.0347C12.0066 30.3678 12.6853 29.9663 13.3509 30.1385C14.0186 30.3117 14.4153 30.9926 14.2464 31.6574C14.0725 32.3243 13.3919 32.7248 12.7273 32.5506C12.0616 32.3794 11.6628 31.7005 11.8347 31.0337V31.0347Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6724 31.6387C16.4895 30.9758 16.8763 30.2889 17.541 30.1047C18.2026 29.9205 18.8842 30.311 19.0721 30.9738C19.254 31.6376 18.8653 32.3255 18.2026 32.5088C17.543 32.692 16.8563 32.3045 16.6734 31.6387H16.6724Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1654 29.7411C20.6757 29.2555 20.6677 28.4705 21.1474 27.9768C21.6321 27.4862 22.4187 27.4832 22.9085 27.9628C23.3962 28.4454 23.4022 29.2344 22.9264 29.727C22.4397 30.2167 21.6531 30.2257 21.1654 29.7421V29.7411Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1054 25.846C23.4408 25.6717 23.04 24.9939 23.2129 24.326C23.3848 23.6602 24.0634 23.2627 24.7291 23.4329C25.3947 23.6061 25.7915 24.286 25.6216 24.9508C25.4487 25.6187 24.771 26.0202 24.1044 25.845L24.1054 25.846Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7104 21.0017C24.0468 21.1829 23.3631 20.7955 23.1762 20.1306C22.9953 19.4678 23.3831 18.7839 24.0468 18.5977C24.7064 18.4154 25.39 18.8039 25.5799 19.4658C25.7628 20.1306 25.373 20.8195 24.7114 21.0017H24.7104Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8158 16.5005C22.3311 16.9911 21.5465 16.9981 21.0538 16.5155C20.566 16.0339 20.557 15.2449 21.0418 14.7522C21.5215 14.2636 22.3101 14.2576 22.7968 14.7352C23.2936 15.2198 23.2986 16.0108 22.8158 16.4995V16.5005Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0365 16.6025C25.0365 16.6025 16.6061 23.0187 16.0134 23.3681C15.4187 23.7186 14.6572 23.5213 14.3083 22.9256C13.9605 22.3318 14.1574 21.5688 14.7501 21.2184C15.3438 20.87 25.0365 16.6025 25.0365 16.6025Z",
    fill: "#456EBE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_116411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.121,
    height: 36.6074,
    fill: "white",
    transform: "translate(0.439453 0.657227)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.bb01d8e00e4692a5578b.svg";
export { ForwardRef as ReactComponent };